import { render, staticRenderFns } from "./Biblioteca.vue?vue&type=template&id=9e8c455a"
import script from "./Biblioteca.vue?vue&type=script&lang=js"
export * from "./Biblioteca.vue?vue&type=script&lang=js"
import style0 from "./Biblioteca.vue?vue&type=style&index=0&id=9e8c455a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports